<div class="document-approval-container">
    <!-- Vista Desktop: Tabla completa original -->
    @if (!appSettings.isMobile()) {
    <div class="table-responsive mt-3">
        <table class="table table-hover table-approval">
            <thead>
                <tr class="text-muted">
                    <th>TIPO DE DOCUMENTO / CATEGORÍA</th>
                    <th class="text-center" style="width: 100px;">OBLIGATORIO</th>
                    <th class="text-center" style="width: 110px;">ESTADO</th>
                    <th class="text-center" style="width: 180px;"><i class="fas fa-cog"></i></th>
                </tr>
            </thead>
            <tbody>
                @for(cat of categories(); track cat.docCategoryCode) {
                    @if (!flat) {
                        <tr>
                            <td colspan="4" class="p-0 border-0">
                                <div class="category-header">
                                    <i class="fas"
                                       [ngClass]="cat.ownerSlug === 'VEHICLE' ? 'fa-car' : (cat.ownerSlug === 'CLAIM' ? 'fa-car-crash' : 'fa-user')"></i>
                                    {{ cat.docCategoryName | uppercase }}
                                    <span class="badge border border-primary text-primary ms-3 rounded-pill">
                                        {{ cat.documents?.length === 1 ? 'requisito: 1' : 'requisitos: ' + (cat.documents?.length || 0) }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    }

                    @for(doc of cat.documents; track doc.uuid || doc.id) {
                        <tr [class.table-warning]="needsResubmit(doc)">
                            <td>
                                <div>
                                    {{ doc.docTypeName }}
                                    @if (doc.source === 'CATALOG_ADD' || doc.source === 'RENEWAL') {
                                        <span class="badge border text-warning ms-1 fw-normal" style="font-size: 0.65rem;">
                                            {{ doc.source === 'RENEWAL' ? 'Renovación' : 'Nuevo requisito' }}
                                        </span>
                                    }
                                </div>
                                @if (needsResubmit(doc) && doc.reviewComment) {
                                    <div class="small text-warning mt-1">
                                        <i class="fas fa-exclamation-circle me-1"></i>{{ doc.reviewComment }}
                                    </div>
                                    @if (canActOnDocs() && !canReplace) {
                                        <div class="small text-muted mt-1">
                                            Esperando reemplazo por la entidad. No puede subir aquí.
                                        </div>
                                    }
                                    @if (canReplace) {
                                        <div class="small text-success mt-1">
                                            Puede reemplazar este archivo con uno nuevo.
                                        </div>
                                    }
                                }
                            </td>
                            <td class="text-center">
                                <input type="checkbox" class="form-check-input" [checked]="doc.isRequired !== false" disabled>
                            </td>
                            <td class="text-center">
                                <span class="badge border fs-12px pb-5px pt-5px px-2 rounded d-inline-flex" 
                                      [ngClass]="doc.statusStyle">
                                    {{ doc.statusName }}
                                </span>
                            </td>
                            <td class="text-center">
                                <div class="d-flex align-items-center justify-content-center gap-1 flex-wrap">
                                    <button type="button" class="btn btn-xs btn-outline-primary"
                                            (click)="openViewer(doc.id)"
                                            [disabled]="!doc.filePath"
                                            title="Ver documento">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                    @if (canObserveDoc(doc)) {
                                        <button type="button" class="btn btn-xs btn-outline-warning"
                                                (click)="requestCorrection(doc)"
                                                title="Pedir corrección de este archivo">
                                            <i class="fas fa-undo"></i>
                                        </button>
                                    }
                                    @if (canShowReplace(doc)) {
                                        <label class="btn btn-xs btn-outline-success mb-0" 
                                               [class.disabled]="isDocumentBusy(doc)"
                                               title="Reemplazar solo este archivo">
                                            @if (isDocumentBusy(doc)) {
                                                <i class="fas fa-spinner fa-spin"></i>
                                            } @else {
                                                <i class="fas fa-upload"></i>
                                            }
                                            <input type="file" class="d-none" accept="image/*,.pdf" 
                                                   [disabled]="isDocumentBusy(doc)"
                                                   (change)="onReplaceFile($event, doc)">
                                        </label>
                                    }
                                </div>
                            </td>
                        </tr>
                    }
                }
                
                @if(categories().length === 0) {
                    <tr>
                        <td colspan="4" class="text-center text-muted p-5">
                            <i class="fas fa-folder-open fa-3x mb-3 d-block"></i>
                            No hay documentos registrados para esta solicitud.
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    } @else {
    <div class="mt-2">
        @for(cat of categories(); track cat.docCategoryCode) {
            @if (!flat) {
                <div class="category-header-mobile d-flex align-items-center justify-content-between my-2 px-1">
                    <span class="fw-bold text-dark text-uppercase small">
                        <i class="fas me-2 text-primary"
                           [ngClass]="cat.ownerSlug === 'VEHICLE' ? 'fa-car' : (cat.ownerSlug === 'CLAIM' ? 'fa-car-crash' : 'fa-user')"></i>
                        {{ cat.docCategoryName }}
                    </span>
                    <span class="badge bg-light text-primary border rounded-pill">
                        {{ cat.documents?.length === 1 ? '1 requisito' : (cat.documents?.length || 0) + ' requisitos' }}
                    </span>
                </div>
            }

            @for(doc of cat.documents; track doc.uuid || doc.id) {
                <app-list-card
                    [isShortcut]="!!doc.filePath"
                    (click)="onMobileCardClick(doc)">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        {{ doc.docTypeName }}
                        @if (doc.isRequired !== false) {
                            <span class="text-danger">*</span>
                        }
                        @if (doc.source === 'CATALOG_ADD' || doc.source === 'RENEWAL') {
                            <span class="badge border text-warning ms-1 fw-normal" style="font-size: 0.65rem;">
                                {{ doc.source === 'RENEWAL' ? 'Renovación' : 'Nuevo requisito' }}
                            </span>
                        }
                    </div>

                    @if (doc.filePath) {
                        <div cardBadge class="doc-card-thumb" aria-hidden="true">
                            @if (documentThumbSrc(doc); as thumb) {
                                <img [src]="thumb" alt="" class="doc-card-thumb-img">
                            } @else if (isPdf(doc)) {
                                <i class="fas fa-file-pdf text-danger"></i>
                            } @else {
                                <i class="fas fa-file text-muted"></i>
                            }
                        </div>
                    }

                    <div class="mb-1">
                        @if (doc.filePath) {
                            <span class="text-success small" style="font-size: 0.75rem;">
                                <i class="fas fa-check-circle me-1"></i>Con archivo
                            </span>
                        } @else {
                            <span class="text-muted small" style="font-size: 0.75rem;">
                                <i class="fas fa-clock me-1"></i>Sin archivo
                            </span>
                        }
                    </div>

                    @if (needsResubmit(doc) && doc.reviewComment) {
                        <div class="small text-warning mt-2 bg-warning bg-opacity-10 p-2 rounded border border-warning">
                            <i class="fas fa-exclamation-circle me-1"></i>{{ doc.reviewComment }}
                        </div>
                    }

                    <span cardExtra class="text-uppercase fw-semibold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">
                        ESTADO
                    </span>
                    <div cardAmount>
                        <span class="badge border" [ngClass]="doc.statusStyle">
                            {{ doc.statusName }}
                        </span>
                    </div>

                    @if (canShowReplace(doc)) {
                        <div cardActionsRow>
                            <label class="btn btn-success btn-sm w-100 mb-0" 
                                   [class.disabled]="isDocumentBusy(doc)"
                                   (click)="$event.stopPropagation()">
                                @if (isDocumentBusy(doc)) {
                                    <i class="fas fa-spinner fa-spin me-1"></i>Subiendo...
                                } @else {
                                    <i class="fas fa-upload me-1"></i>Reemplazar
                                }
                                <input type="file" class="d-none" accept="image/*,.pdf" 
                                       [disabled]="isDocumentBusy(doc)"
                                       (change)="onReplaceFile($event, doc)">
                            </label>
                        </div>
                    }
                </app-list-card>
            }
        }

        @if(categories().length === 0) {
            <div class="text-center text-muted p-4">
                <i class="fas fa-folder-open fa-3x mb-3 d-block text-muted opacity-50"></i>
                No hay documentos registrados para esta solicitud.
            </div>
        }
    </div>
    }

    @if(isViewerOpen() && activeDocId()) {
        <app-viewer 
            [items]="viewerItems()" 
            [activeId]="activeDocId()"
            (close)="closeViewer()"
            (onSelect)="onDocSelect($event)">
            <div viewer-actions class="d-flex gap-2 pe-3 flex-wrap" style="border-right: 1px solid rgba(255,255,255,0.2);">
                @if (canAcceptDoc(getActiveDoc())) {
                    <button type="button" class="btn btn-sm btn-success" (click)="approveDocument()">
                        <i class="fas fa-check"></i>
                        {{ acceptLabel(appSettings.isMobile()) }}
                    </button>
                }
                @if (canObserveDoc(getActiveDoc())) {
                    <button type="button" class="btn btn-sm btn-warning" (click)="requestCorrection()">
                        <i class="fas fa-undo"></i>
                        {{ appSettings.isMobile() ? 'Observar' : 'Pedir corrección' }}
                    </button>
                }
                @if (canShowReplace(getActiveDoc())) {
                    <label class="btn btn-sm btn-outline-light mb-0" 
                           [class.disabled]="isDocumentBusy(getActiveDoc())">
                        @if (isDocumentBusy(getActiveDoc())) {
                            <i class="fas fa-spinner fa-spin me-1"></i>
                        } @else {
                            <i class="fas fa-upload me-1"></i>
                        }
                        {{ appSettings.isMobile() ? 'Reemplazar' : 'Reemplazar archivo' }}
                        <input type="file" class="d-none" accept="image/*,.pdf" 
                               [disabled]="isDocumentBusy(getActiveDoc())"
                               (change)="onReplaceFile($event, getActiveDoc())">
                    </label>
                }
            </div>
        </app-viewer>
    }
</div>
